





import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class JdsPanelTab extends Vue {
    @Prop({default: false, type: Boolean}) active!: boolean;
}
